import { render, staticRenderFns } from "./template-form-base.vue?vue&type=template&id=ed7a5a50&lang=pug&"
import script from "./template-form-base.vue?vue&type=script&lang=ts&"
export * from "./template-form-base.vue?vue&type=script&lang=ts&"
import style0 from "./template-form-base.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports